import React, {Component} from "react";
import AsyncSelect from "react-select/async"
import Jquery from "jquery";

class CategorySelect extends Component {

    styles = {
        option: (provided, state) => ({
            ...provided,
            background: state.isFocused ? "#182237" : "none",
            color: state.isFocused ? "#fff" : "#6c757d",
            fontSize: "14px",
            padding: "9px 15px",
        })
    };

    loadOptions = async (query) => {
        let response = await fetch(`${this.props.endpoint}/api/de/categories?query=${encodeURIComponent(query)}&limit=7`);
        let categories = await response.json();
        return categories.map((category) => {
            return {
                value: category.id,
                label: category.name
            }
        });
    };

    render() {
        return (
            <div className="form-group">
                <div className="input-group mb-2 icon">
                    <div className="input-group-prepend"/>
                    <i className="lni-tag"> </i>
                    <AsyncSelect
                        styles={this.styles}
                        placeholder={""}
                        className={"select"}
                        classNamePrefix={"select"}
                        loadOptions={this.loadOptions}
                        noOptionsMessage={() => "kein Suchergebnis"}
                        value={this.props.value}
                        onChange={this.props.onChange}
                        onFocus={() => {
                            Jquery("#category-label").addClass("focused-label");
                        }}
                        onBlur={() => {
                            if (!this.props.value) {
                                Jquery("#category-label").removeClass("focused-label");
                            }
                        }}
                        required={true}
                        searchable={true}
                        ref={(ref) => {
                            this.select = ref;
                        }}
                    />
                    <input
                        tabIndex={-1}
                        value={this.props.value}
                        required={true}
                        style={{
                            opacity: 0,
                            width: 0,
                            height: 0,
                            position: "absolute",
                        }}
                        onChange={() => {
                        }}
                        onFocus={() => this.select.focus()}
                    />

                    <label className={"form-label"} id={"category-label"}>Branche</label>
                </div>
            </div>
        );
    }
}

export default CategorySelect;


